import type { YaasLpPositionIdentity } from "@solomon-apps/shared/src/types/yaas";
import type { RpcClient } from "@solomon-labs/solana-rpc-client";

export type LpRpc = Pick<RpcClient, "request">;

/** Raw RPC wire data, validated before decoding (not yet branded SDK values). */
export interface RpcAccount {
    owner: string;
    data: [string, string];
}

export interface RpcAccountsResponse {
    context: { slot: number };
    value: Array<RpcAccount | null>;
}

export interface ParsedTokenInfo {
    owner: string;
    mint: string;
    tokenAmount: { amount: string; decimals: number };
}

// The SDK token-account response models base64, not jsonParsed encoding.
export interface ParsedTokenAccountsResponse {
    context: { slot: number };
    value: Array<{ account: { data: { parsed: { info: ParsedTokenInfo } } } }>;
}

export interface LpBalance {
    amount: string;
    slot: number;
}

/** The CLMM-only RPC reader's label, and the landing preview's LP row. */
export const RAYDIUM_CLMM_LABEL = "Raydium CLMM";

/** The pool an LP holding sits in, with the pair label the UI shows for it. */
export interface RaydiumLpPool extends Pick<YaasLpPositionIdentity, "protocol" | "poolAddress" | "observedAssetMint"> {
    displayName: string;
}

/** Display holding only: no Program Position ID, reward status or routing actions. */
export interface RaydiumLpHolding {
    key: string;
    pool: RaydiumLpPool;
    positionAddress: string;
    /** RPC discovery supplies the NFT mint; API discovery supplies the canonical position PDA. */
    nftMint?: string;
    amount: string | null;
}
